export const GET_SEARCHED_RESULT = 'search/GET_SEARCHED_RESULT';
export const GET_SEARCHED_RESULT_SUC = 'search/GET_SEARCHED_RESULT_SUC';
export const GET_SEARCHED_RESULT_ERR = 'search/GET_SEARCHED_RESULT_ERR';
export const RESET_SEARCHED_RESULT = 'search/RESET_SEARCHED_RESULT'

export const SAGA_GET_SEARCHED_RESULT = 'search/SAGA_GET_SEARCH';
